import { useCallback } from 'react'
import {
	ApiPostWithToken,
	useApiPost
} from 'shared/api'
import {
	searchApiBy
} from 'interface/endpoints'
import {
	PredictionResult,
	PredictionCondition,
	PredictionData
} from './types'

import { SharedListUploadResult } from '../sharedList'

export * from './types'

export const usePredictionRequest = (
	searchId: number | null,
	callback?: {
    onFinished?: (result: PredictionData) => void
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<{
	uploadResult: SharedListUploadResult
	predictionCondition: PredictionCondition
}, PredictionResult>(
	useCallback(
		(apiAccess, cancelToken, { uploadResult, predictionCondition }, webSocketId) => {
			if (!searchId) return null
			if (predictionCondition.source === 'lv') {
				return ApiPostWithToken(
					apiAccess,
					searchApiBy(searchId, `/prediction/lv/${uploadResult.sharedList.sharedListId}`),
					predictionCondition,
					cancelToken,
					webSocketId
				)
			} else if (predictionCondition.source === 'mrp') {
				return ApiPostWithToken(
					apiAccess,
					searchApiBy(searchId, `/prediction/mrp/${uploadResult.sharedList.sharedListId}`),
					predictionCondition,
					cancelToken,
					webSocketId
				)
			} else {
				return null
			}
		},
		[searchId]
	),
	useCallback(
		(result, { uploadResult, predictionCondition }) => {
			if (callback?.onFinished) {
				callback.onFinished({
					uploadResult,
					predictionCondition,
					predictionResult: result
				})
			}
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)
